import socket from '@/plugins/socket'
import Day from '@/store/model/sport/sport/Day'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    load: (state, datas) => {
      state.list = []
      datas = datas.sort((a, b) => {
        if (b.date && a.date) {
          const dateA = new Date(a.date)
          const dateB = new Date(b.date)
          return dateB.getTime() - dateA.getTime()
        } else {
          return b.name - a.name
        }
      })

      for (const i in datas) {
        const data = datas[i]
        const founded = state.list.find((item) => { return item.id === data.id })
        if (!founded) {
          state.list.push(new Day(data))
        }
      }
    }
  },
  actions: {
    set (state, data) {
      state.state.list = []

      if (data.sportId > 0 || data.competitionsId > 0) {
        const parameters = { join: ['SportSportDay.groupId', 'SportSportGroup.roundId'], joinr: [] }

        if (data.groupsTypeId > 0) {
          if (data.groupsTypeId.length === 1) {
            parameters['SportSportGroup.roundTypeId'] = data.groupsTypeId[0]
          } else {
            parameters['SportSportGroup.groupTypeId'] = {
              column: 'SportSportGroup.groupTypeId',
              operator: 'in',
              value: data.groupsTypeId
            }
          }
        }

        if (data.roundsTypeId > 0) {
          if (data.roundsTypeId.length === 1) {
            parameters['SportSportRound.roundTypeId'] = data.roundsTypeId[0]
          } else {
            parameters['SportSportRound.roundTypeId'] = {
              column: 'SportSportRound.roundTypeId',
              operator: 'in',
              value: data.roundsTypeId
            }
          }
        }

        // competition
        if (data.seasonId > 0 || data.competitionsId.length > 0) {
          parameters.join.push('SportSportRound.competitionSeasonId')

          if (data.seasonId > 0) {
            parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
          }

          if (data.competitionsId.length === 1) {
            parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
          } else if (data.competitionsId.length > 1) {
            parameters['SportSportCompetitionseason.competitionId'] = {
              column: 'SportSportCompetitionseason.competitionId',
              operator: 'in',
              value: data.competitionsId
            }
          }
        }

        // discipline
        if (data.eventUnitsId > 0) {
          parameters['SportSportRound.eventUnitId'] = {
            value: data.eventUnitsId,
            operator: 'in'
          }
        } else {
          parameters.join.push('SportSportRound.eventUnitId')

          if (data.categoryId > 0) {
            parameters['SportSportEventunit.categoryId'] = data.categoryId
          }

          if (data.eventId > 0) {
            parameters['SportSportEventunit.eventId'] = data.eventId
          } else if (data.disciplineId > 0) {
            parameters['SportSportEvent.disciplineId'] = data.disciplineId
            parameters.join.push('SportSportEventunit.eventId')
          } else if (data.sportId > 0) {
            parameters['SportSportDiscipline.sportId'] = data.sportId
            parameters.join.push('SportSportEventunit.eventId')
            parameters.join.push('SportSportEvent.disciplineId')
          }

          if (data.genderId > 0) {
            parameters['SportSportEventunit.genderId'] = data.genderId
          }

          // todo : Classification
        }

        socket.get('SportSportDay', 'Sport/Day/load', parameters)
      }
    }
  },
  getters: {
    list: (state) => state.list
  }
}
